module.exports = __webpack_public_path__ + "img/00032.4d8bbe98.webp";